const Divide = () => {
  return <div className="divide"></div>
}

export default Divide
